//||------------------------script------------------------||
//||                                                      ||
//||           js skript: Logik für das Side-Menü         ||
//||                                                      ||
//||------------------------script------------------------||
// Discription:
/* 
Controls the visibility and behavior of top menu / side menu.
*/

const menuTopButton = document.getElementById("menu-on");
const menuTop = document.getElementById("topMenu");
const sideMenu = document.getElementById("sideMenu");
const toggleMenu = document.querySelectorAll("#hamburger_btn, #sideMenu");

// scrolling started at the top of the page
let scrollStartedAtTop = false;

function toggleMenuButton() {
  // if page is at the very top: show top menu
  if (window.scrollY === 0) {
    scrollStartedAtTop = true;
    if (menuTop) {
      menuTop.classList.remove("-translate-y-[calc(100%+16px)]");
      menuTop.classList.add("translate-y-0");
    }
    if (menuTopButton) {
      menuTopButton.classList.add("hidden");
    }
    return;
  }

  // if user scrolls down after being at the top
  if (scrollStartedAtTop && window.scrollY > 0) {
    if (menuTop) {
      menuTop.classList.remove("translate-y-0");
      menuTop.classList.add("-translate-y-[calc(100%+16px)]");
    }
    if (menuTopButton) {
      menuTopButton.classList.remove("active");

      // show the menu btn when scrolling
      menuTopButton.classList.remove("hidden");
    }
    scrollStartedAtTop = false;
  }
}

function toggleSideMenu() {
  if (!sideMenu) return;

  // Wenn das Menü versteckt ist, schiebe es ins Bild
  if (sideMenu.classList.contains("translate-x-full")) {
    sideMenu.classList.remove("translate-x-full");
    sideMenu.classList.add("translate-x-0");
  } else {
    // Wenn es offen ist, schiebe es wieder raus
    sideMenu.classList.remove("translate-x-0");
    sideMenu.classList.add("translate-x-full");
  }
}

// ------------------------
// trigger
// ------------------------

// triggered when hamburger btn is clicked: toggles side menu
toggleMenu.forEach((button) => {
  button.addEventListener("click", toggleSideMenu);
});

// triggered when top menu btn is clicked
function toggleTopMenu() {
  sideMenu.classList.remove("translate-x-0");
  sideMenu.classList.add("translate-x-full");

  if (menuTop) {
    menuTop.classList.toggle("translate-y-0");
    menuTop.classList.toggle("-translate-y-[calc(100%+16px)]");
  }
  menuTopButton.classList.toggle("active");
}
window.toggleTopMenu = toggleTopMenu;

// Detect scrolling and update menu state
window.addEventListener("scroll", toggleMenuButton);

// initial state setup
toggleMenuButton();
